import styled from 'styled-components';

import Box from '../Box';

export interface StyledStepsProps {
  concealed?: boolean;
}

export default styled(Box)<StyledStepsProps>`
  .ant-steps-item-icon {
    display: inline-flex;
    justify-content: center;
    align-items: center;
  }
  * {
    font-weight: 400;
  }
`;
